<template>
  <div>
    <validation-observer ref="form" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">

        <div class="form-top-part-section">
          <div class="input-group-request-path mb-medium">
            <validation-provider style="flex: 1" name="name" v-slot="validationContext">
              <b-form-group>
                <b-form-input
                  class="form-control"
                  v-model="mockRule.name"
                  placeholder="Mock rule name"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-button class="ml-medium" icon variant="primary" v-if="!mockRule.id" @click="onSubmit">
              <b-spinner small v-if="savingInProgress"></b-spinner>
              <span class="ml-standard" v-if="savingInProgress">Saving...</span>
              <span v-if="!savingInProgress"><i class="fas fa-save mr-small"></i> Save</span>
            </b-button>

            <b-dropdown class="ml-medium" split right :variant="mockRule.canEdit ? 'primary' : 'warning'" @click="onSubmit" v-if="mockRule.id">
              <template slot="button-content">
                <b-spinner small v-if="savingInProgress"></b-spinner>
                <span class="ml-standard" v-if="savingInProgress">Saving...</span>
                <span v-if="!savingInProgress"><i class="fas fa-save mr-small"></i> Save</span>
              </template>
              <b-dropdown-item @click="openRuleCreatorByClone(mockRule)" :disabled="!mockRule.id">
                <span>Clone mock rule</span>
              </b-dropdown-item>
<!--              <b-dropdown-item @click="openRuleCreatorByClone(mockRule)" :disabled="!mockRule.id">-->
<!--                <span class="text-danger">Delete</span>-->
<!--                TODO mstrzelecki dialog delete confirmation -->
<!--              </b-dropdown-item>-->
            </b-dropdown>
          </div>

          <div class="d-flex mt-medium mb-medium">
            <validation-provider name="method" rules="required" v-slot="validationContext">
              <b-form-group>
                <b-form-select
                  class="form-control-left"
                  style="width: 90px; font-weight: 600"
                  v-model="mockRule.requestMatcher.method"
                  :options="httpMethods"
                  :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider style="flex: 1" name="requestMatcher.path" v-slot="validationContext">
              <b-form-group>
                <b-form-input
                  class="form-control-middle"
                  v-model="mockRule.requestMatcher.path"
                  placeholder="/api/example/endpoint"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider name="priority" rules="required" v-slot="validationContext">
              <b-form-group style="width: 52px">
                <b-form-select
                  class="form-control-right"
                  v-model="mockRule.priority"
                  :options="mockPriorities"
                  value-field="value"
                  text-field="name"
                  :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>

          <div class="d-flex mb-medium">
            <b-button variant="secondary" class="btn-small mr-standard" @click="addQueryMatcher">
              <i class="fas fa-plus-circle"></i> query matcher
            </b-button>
            <b-button variant="secondary" class="btn-small mr-standard" @click="addHeaderMatcher">
              <i class="fas fa-plus-circle"></i> header matcher
            </b-button>
            <b-button variant="secondary" class="btn-small mr-standard" @click="addBodyMatcher">
              <i class="fas fa-plus-circle"></i> body matcher
            </b-button>
          </div>

          <request-matcher v-model="mockRule.requestMatcher.queryValueMatchers" name="query" hintKey="param key"></request-matcher>

          <request-matcher v-model="mockRule.requestMatcher.headerValueMatchers" name="header" hintKey="header key"></request-matcher>

          <request-matcher v-model="mockRule.requestMatcher.bodyValueMatchers" name="body" hintKey="object field path"></request-matcher>
        </div>

        <div class="form-top-part-section d-flex">
          <validation-provider name="mockRule.mockResponse.statusCode" rules="required" v-slot="validationContext">
            <b-form-group class="mr-medium" style="width: 200px">
              <b-form-select
                class="form-control"
                v-model="mockRule.mockResponse.statusCode"
                :options="httpStatusCodes"
              ></b-form-select>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider style="flex: 1" name="executeMode" rules="required" v-slot="validationContext">
            <b-form-group>
              <b-form-select
                v-model="mockRule.executeMode"
                :options="executeModes"
                value-field="value"
                text-field="name"
                :state="getValidationState(validationContext)"
              ></b-form-select>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>

        <b-tabs>
          <b-tab>
            <template #title>
              Mock Headers
            </template>
            <v-key-value-editor
              class="input-group-json"
              v-model="mockRule.mockResponse.headers"
              key-placeholder="header key"
              value-placeholder="header value"
              add-button-name="new header"
            ></v-key-value-editor>
          </b-tab>

          <b-tab active>
            <template #title>
              Mock Body
            </template>
            <v-ace-editor
              class="input-group-json"
              ref="mockResponseEditorRef"
              v-model="mockRule.mockResponse.body.data"
              :content-type="mockRule.mockResponse.body.contentType"
              @on-change-content-type="changedContentType"
            ></v-ace-editor>
          </b-tab>

          <b-tab>
            <template #title>
              Network
            </template>
            <div class="d-flex mt-large mb-large ml-large mr-large">
              <validation-provider name="networkDelay" v-slot="validationContext">
                <b-form-group style="width: 250px;">
                  <b-form-input
                    id="input-mock-rule-network-delay"
                    v-model="mockRule.networkDelay"
                    placeholder="Delay duration (optional)"
                    type="number"
                    :state="getValidationState(validationContext)"
                  ></b-form-input>
                  <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>
          </b-tab>
        </b-tabs>

        <modal-invalided-mock ref="modalInvalidMockRef"></modal-invalided-mock>
        <modal-select-profile ref="modalSelectProfileRef" :on-success="changeContextProfileAndResubmit"></modal-select-profile>

      </b-form>
    </validation-observer>
  </div>
</template>
<script>
  import {getContextProfileToken} from "../../util/localstorage";
  import ModalInvalidedMock from "./ModalInvalidedMock";
  import ModalSelectProfile from "./ModalSelectProfile";
  import VAceEditor from "../../components/editors/ace/AceEditor";
  import VKeyValueEditor from "../../components/editors/keyvalue/KeyValueEditor";
  import axios from 'axios';

  export default {
    components: {ModalInvalidedMock, ModalSelectProfile, VAceEditor, VKeyValueEditor},
    data() {
      return {
        mockPriorities: [
          {name: "9 (highest)", value: 9},
          {name: "8", value: 8},
          {name: "7", value: 7},
          {name: "6", value: 6},
          {name: "5 (default)", value: 5},
          {name: "4", value: 4},
          {name: "3", value: 3},
          {name: "2", value: 2},
          {name: "1 (lowest)", value: 1}
        ],
        ikoStatus: "OK",
        httpMethods: [],
        httpStatusCodes: [],
        contentTypes: [],
        executeModes: [],
        userProfiles: [],
        mockRule: this.createDefaultRule(),
        savingInProgress: false,
        creationByTemplate: false
      };
    },
    created() {
      this.fetchHttpMethods();
      this.fetchHttpResponseStatus();
      this.fetchContentTypes();
      this.fetchExecuteModes();
      this.fetchUserProfiles();

      if (this.$route.params.id) {
        this.fetchRuleById(this.$route.params.id)
      } else if (this.$route.query.templateRuleId) {
        this.fetchTemplateByMockRule(this.$route.query.templateRuleId)
      } else if (this.$route.query.templateCallLogId) {
        this.fetchTemplateByCallLogId(this.$route.query.templateCallLogId)
      }
    },
    methods: {
      getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
      },
      fetchUserProfiles() {
        axios.get(`/api/mockConfig/user/profiles`)
          .then(response => {
            this.userProfiles = response.data;
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchHttpMethods() {
        axios.get(`/api/mockConfig/httpMethods`)
          .then(response => {
            this.httpMethods = response.data
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchHttpResponseStatus() {
        axios.get(`/api/mockConfig/httpStatuses`)
          .then(response => {
            this.httpStatusCodes = response.data
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchContentTypes() {
        axios.get(`/api/mockConfig/contentTypes`)
          .then(response => {
            this.contentTypes = response.data
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchExecuteModes() {
        axios.get(`/api/mockConfig/mockExecuteModes`)
          .then(response => {
            this.executeModes = response.data
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchRuleById(ruleId) {
        axios.get(`/api/mockConfig/mockRule/${ruleId}/edit`)
          .then(response => {
            this.mockRule = response.data;
            this.creationByTemplate = false;
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchTemplateByMockRule(ruleId) {
        axios.get(`/api/mockConfig/mockRule/template/mockRule/${ruleId}`)
          .then(response => {
            this.mockRule = response.data;
            this.mockRule.profileToken = getContextProfileToken();
            this.creationByTemplate = true;
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      fetchTemplateByCallLogId(callLogId) {
        axios.get(`/api/mockConfig/mockRule/template/callLog/${callLogId}`)
          .then(response => {
            this.mockRule = response.data;
            this.mockRule.profileToken = getContextProfileToken();
            this.creationByTemplate = true;
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      changeContextProfileAndResubmit(profileToken) {
        this.mockRule.profileToken = profileToken;
        this.onSubmit();
      },
      onSubmit() {
        const errorAnnotations = this.$refs.mockResponseEditorRef.getAnnotations();
        if (errorAnnotations.length > 0) {
          this.$refs.modalInvalidMockRef.showModal(errorAnnotations);
          return
        } else if (this.creationByTemplate && this.userProfiles.filter(profile => profile.token === this.mockRule.profileToken).length === 0) {
          this.$refs.modalSelectProfileRef.showModal(this.userProfiles);
          return
        }
        this.savingInProgress = true;
        axios.post(`/api/mockConfig/mockRule`, this.mockRule)
          .then(response => {
            if (this.mockRule.profileToken === getContextProfileToken()) {
              this.$bus.emit('mockRule:edited');
            }
            if (this.mockRule.id) {
              this.$notify({type: 'success', message: 'Changes on mock rule was saved'});
            } else {
              this.$notify({type: 'success', message: 'New mock rule was created'});
            }
            if (this.$route.path !== '/mock-rule/' + response.data.id + "/edit") {
              this.$router.push({name: 'mockRuleEditor', params: {id: response.data.id}});
            }
          })
          .catch(e => {
            this.$onError(e, this.$refs.form);
          })
          .finally(() => {
            this.savingInProgress = false;
          })
      },
      addQueryMatcher() {
        this.mockRule.requestMatcher.queryValueMatchers.push({key: "", strategy: "EQUAL", value: ""});
      },
      addBodyMatcher() {
        this.mockRule.requestMatcher.bodyValueMatchers.push({key: "", strategy: "EQUAL", value: ""});
      },
      addHeaderMatcher() {
        this.mockRule.requestMatcher.headerValueMatchers.push({key: "", strategy: "EQUAL", value: ""});
      },
      openRuleCreatorByClone(mockRule) {
        this.$router.push({name: 'mockRuleCreator', query: {templateRuleId: mockRule.id}})
      },
      createDefaultRule() {
        return {
          id: null,
          profileToken: getContextProfileToken(),
          name: null,
          description: null,
          enabled: true,
          networkDelay: null,
          priority: 5,
          canEdit: true,
          executeMode: "ALWAYS",
          requestMatcher: {
            path: null,
            method: "POST",
            queryValueMatchers: [],
            bodyValueMatchers: [],
            headerValueMatchers: []
          },
          mockResponse: {
            statusCode: "200",
            statusName: null,
            headers: {
              "content-type": "application/json;charset=UTF-8",
            },
            body: {
              contentType: "JSON",
              data: {
              }
            }
          }
        }
      },
      changedContentType(contentType) {
        this.mockRule.mockResponse.body.contentType = contentType;
        if (this.mockRule.mockResponse.body.contentType === 'JSON' && this.mockRule.mockResponse.body.data.responseStatus) {
          this.mockRule.mockResponse.body.data.responseStatus = this.ikoStatus;
        }
      },
    },
    watch: {
      'ikoStatus': function (ikoStatus) {
        if (this.mockRule.mockResponse.body.contentType === 'JSON' && this.mockRule.mockResponse.body.data.responseStatus) {
          this.mockRule.mockResponse.body.data.responseStatus = ikoStatus;
        }
      },
      'mockRule.mockResponse.body.data.responseStatus': function (responseStatus) {
        this.ikoStatus = responseStatus;
      },
      '$route.params.id': function (id) {
        if (id) {
          this.fetchRuleById(id);
        } else {
          this.mockRule = this.createDefaultRule()
        }
      },
      '$route.query.templateRuleId': function (id) {
        if (id) {
          this.fetchTemplateByMockRule(id);
        } else {
          this.mockRule = this.createDefaultRule()
        }
      },
      '$route.query.templateCallLogId': function (id) {
        if (id) {
          this.fetchTemplateByCallLogId(id);
        } else {
          this.mockRule = this.createDefaultRule()
        }
      }
    }
  };
</script>
<style>

</style>
